export const getToken = () => localStorage.getItem("token");

export const setToken = (token: string) => {
  localStorage.setItem("token", token);
};

export const clearToken = () => {
  localStorage.removeItem("token");
};

/** El `exp` del token, en milisegundos. `null` si no se puede leer. */
const expiryOf = (token: string): number | null => {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    // base64url → base64, y un decodificador que no se atragante con los acentos del nombre.
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${c.charCodeAt(0).toString(16).padStart(2, "0")}`)
        .join("")
    );

    const exp = JSON.parse(json)?.exp;

    return typeof exp === "number" ? exp * 1000 : null;
  } catch {
    return null;
  }
};

/**
 * Si hay sesión utilizable.
 *
 * Un token caducado sigue siendo una cadena en `localStorage`, así que comprobar solo que exista
 * dejaba entrar a `/home` sin sesión: la pantalla montaba, el usuario interactuaba, y el fallo
 * aparecía en la primera llamada que sí miraba la respuesta —normalmente la del PDF—. Desde fuera
 * parecía que el PDF estaba roto.
 *
 * Un token que no se puede leer se trata como inválido: si no sabemos cuándo caduca, no es nuestro.
 *
 * Se adelanta diez segundos a propósito: uno que caduca dentro de cinco va a fallar a mitad de la
 * petición, y es mejor mandar a iniciar sesión antes que a medias.
 */
export const hasValidSession = (): boolean => {
  const token = getToken();
  if (!token) return false;

  const expiry = expiryOf(token);
  if (expiry === null) return false;

  return expiry - 10_000 > Date.now();
};
